import React from 'react';
import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
`;

const Spinner = styled.div`
    margin-right: ${(props) => (props.marginRight ? props.marginRight : '0px')};
    margin-top: ${(props) => (props.marginTop ? props.marginTop : '0px')};
    margin-bottom: ${(props) =>
        props.marginBottom ? props.marginBottom : '0px'};
    height: ${(props) => (props.size ? props.size : '15px')};
    width: ${(props) => (props.size ? props.size : '15px')};
    border: 3px solid;
    border-color: ${(props) =>
        props.primary ? 'white' : props.theme.businessPrimaryColor};
    border-right: 3px solid transparent;
    border-radius: 50%;
    animation: ${rotate} 1s linear infinite;
`;

const StyledCenteredSpinner = styled.div`
    margin-top: ${(props) => (props.marginTop ? props.marginTop : '0px')};
    margin-bottom: ${(props) =>
        props.marginBottom ? props.marginBottom : '0px'};
    display: flex;
    justify-content: center;
`;

export const CenteredSpinner = (props) => (
    <StyledCenteredSpinner id="spinner" {...props}>
        <Spinner {...props} />
    </StyledCenteredSpinner>
);

export default Spinner;
